/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-CMS Content Block API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ContentBlockLinkRestDto } from '../models';
import { IdResponseRestDto } from '../models';
/**
 * ContentBlockLinkEndpointsApi - axios parameter creator
 * @export
 */
export const ContentBlockLinkEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CMS.CB.40 Add a link between a two content blocks.
         * @param {ContentBlockLinkRestDto} body 
         * @param {string} x_dp_customer_code The unique identification of the Customer of the from content block.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContentBlockLink: async (body: ContentBlockLinkRestDto, x_dp_customer_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createContentBlockLink.');
            }
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling createContentBlockLink.');
            }
            const localVarPath = `/content_block/v1/content_block_link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentBlockLinkEndpointsApi - functional programming interface
 * @export
 */
export const ContentBlockLinkEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CMS.CB.40 Add a link between a two content blocks.
         * @param {ContentBlockLinkRestDto} body 
         * @param {string} x_dp_customer_code The unique identification of the Customer of the from content block.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContentBlockLink(_axios: AxiosInstance, body: ContentBlockLinkRestDto, x_dp_customer_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdResponseRestDto>> {
            const localVarAxiosArgs = await ContentBlockLinkEndpointsApiAxiosParamCreator(configuration).createContentBlockLink(body, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContentBlockLinkEndpointsApi - object-oriented interface
 * @export
 * @class ContentBlockLinkEndpointsApi
 * @extends {BaseAPI}
 */
export class ContentBlockLinkEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary REST.API.CMS.CB.40 Add a link between a two content blocks.
     * @param {ContentBlockLinkRestDto} body 
     * @param {string} x_dp_customer_code The unique identification of the Customer of the from content block.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentBlockLinkEndpointsApi
     */
     public createContentBlockLink(body: ContentBlockLinkRestDto, x_dp_customer_code: string, options?: any) {
        return ContentBlockLinkEndpointsApiFp(this.configuration).createContentBlockLink(this.axios, body, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

}
